<template>
    <div class="modal-card">
        <header class="modal-card-head">
            <p class="modal-card-title">Link to Invenias</p>
        </header>
        <section class="modal-card-body">
            <loading v-if="loading"></loading>
            <o-tabs v-model="tab" class="hide-step-nav" v-else>
                <o-tab-item title="Search" value="search">
                    <o-field label="Company name">
                        <o-input v-model="search" icon="search"></o-input>
                    </o-field>
                </o-tab-item>
                <o-tab-item value="results">
                    <div class="columns is-multiline">
                        <div class="column is-12 has-text-centered" v-if="options?.length == 0">
                            No Results
                            <div class="mt-2 is-flex is-justify-content-center" style="gap: 20px;">
                                <o-button icon-left="pencil" @click="tab = 'search'">Modify search</o-button>
                                <o-button @click="NewCompany" icon-left="plus" :disabled="creating" :loading="creating">Create new Invenias company</o-button>
                            </div>
                        </div>
                        <div style="width: 100%;" v-else>
                            <div class="column is-12 columns is-multiline">
                                <div class="column is-6">
                                    <o-button class="mb-4" @click="ConfirmNewCompany" icon-left="plus" :disabled="creating" :loading="creating">Create new Invenias company</o-button>
                                    <h4>Search results for {{ search }}</h4>
                                    <div class="my-5">
                                        <o-field v-for="(opt, i) in options" :key="i">
                                            <o-radio v-model="selection" name="dupe" :native-value="opt.ItemId">{{ opt.DisplayName }}</o-radio>
                                        </o-field>
                                    </div>
                                    <o-button icon-left="pencil" @click="tab = 'search'">Modify search</o-button>
                                </div>
                                <div class="column is-6 link-company-border" v-if="loadingInfo">
                                    <div style="position:sticky; top:0">
                                        <loading></loading>
                                    </div>
                                </div>
                                <div class="column is-6 link-company-border" v-if="info != null && !loadingInfo">
                                    <div style="position: sticky; top:0">
                                        <h3>
                                            <a :href="$filters.InveniasUrl(info.Id)" target="_blank">{{ info.CompanyName }} <o-icon icon="external-link" /></a>
                                        </h3>
                                        <div class="mt-2" v-if="defaultWebsite">
                                            <a :href="defaultWebsite" target="_blank">{{ defaultWebsite }}</a>
                                        </div>
                                        <div class="mt-2">
                                            {{ info.DefaultLocation.AddressComponents.FullAddress }}
                                        </div>

                                        <info-line label="Is Client?">
                                            <o-icon icon="check" variant="success" v-if="info.IsClient"></o-icon>
                                            <o-icon icon="times" variant="danger" v-else></o-icon>
                                        </info-line>
                                        <info-line label="Assignments" :value="totalAssignments"></info-line>
                                        <info-line label="People" :value="totalPeople"></info-line>
                                        <info-line label="Linked to ZoomInfo">
                                            <o-icon icon="check" variant="success" v-if="$filters.FixExternalId(info.ExternalId2)"></o-icon>
                                            <o-icon icon="times" variant="danger" v-else></o-icon>
                                        </info-line>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                </o-tab-item>
            </o-tabs>
        </section>
        <footer class="modal-card-foot is-justify-content-space-between">
            <div>
                <o-button variant="light" @click="Close">Close</o-button>
            </div>
            <div>
                <o-button variant="primary" :disabled="loading" @click="SearchCompanies" v-if="tab == 'search'">Search</o-button>
                <o-button variant="primary" :disabled="loading || loadingInfo || !selection" @click="Link" v-if="tab == 'results'">
                    Link
                </o-button>
            </div>
        </footer>
    </div>
</template>
<script>
    import infoLine from "@/components/webComponents/infoLine.vue";
    import editCompanyModal from "@/components/modals/new-company.vue";
    import { ref, computed, inject, watch, onMounted, getCurrentInstance } from "vue";

    export default {
        components: {
            infoLine
        },
        props: {
            company: {
                type: Object,
                default: () => {
                    return {};
                }
            }
        },
        emits: ["close"],
        setup(props, context) {
            const oruga = inject("oruga");
            const http = inject("$http");
            const success = inject("$success");
            const error = inject("$error");

            const loadingInfo = ref(false);
            const loading = ref(true);
            const isValid = ref(true);
            const options = ref([]);
            const selection = ref();
            const info = ref(null);
            const tab = ref('search');
            const search = ref(props.company.Name);
            const creating = ref(false);


            const defaultWebsite = computed(() => {
                if (info.value) {
                    const defaultWebsites = info.value.Websites.filter(x => x.IsVisibleAsDefault);
                    if (defaultWebsites.length > 0) {
                        const item = defaultWebsites[0];
                        if (item.ItemValue) return item.ItemValue;
                        else if (item.DefaultValue) return item.DefaultValue;
                        else if (item.FieldName == "LinkedIn") return "https://www.linkedin.com/company/" + info.value.CompanyName;
                        //return defaultWebsites[0];
                        return "";
                    }
                    else return "N/A";
                }
                else return null;
            });

            const totalPeople = computed(() => {
                return info.value?.People?.length || 0;
            });

            const totalAssignments = computed(() => {
                return info.value?.Assignments?.length || 0;
            })

            const SearchCompanies = async () => {
                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/invenias/search?companyName=" + encodeURIComponent(search.value));
                    options.value = resp.data;
                } catch (err) {
                    console.error(err);
                }
                tab.value = 'results';
                loading.value = false;
            }

            const GetInveniasCompanyInfo = async (itemId) => {
                loadingInfo.value = true;

                try {
                    const resp = await http.get("/api/v2/company/invenias/" + itemId);
                    info.value = resp.data;
                } catch (err) {
                    console.error(err);
                }

                loadingInfo.value = false;
            }

            const Close = () => {
                context.emit("close");
            };

            const Link = async () => {
                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/" + props.company.ID + "/invenias/" + selection.value + "/link");
                    context.emit("close", { linked: true, inveniasId: selection.value });
                    success("Linked company to Invenias.");
                } catch (err) {
                    console.error(err);
                }
                loading.value = false;
            }

            const NewCompany = async () => {
                creating.value = true;
                loading.value = true;
                try {
                    const resp = await http.get("/api/v2/company/" + props.company.ID + "/invenias/create");
                    context.emit("close", { linked: true, inveniasId: resp.data.InveniasID });
                    success("New Invenias record created");
                } catch (err) {
                    console.error(err);
                    error(err?.response?.data || "Mcl company does not exist.");
                }
                loading.value = false;
                creating.value = false;

                /*
                oruga.modal.open({
                    parent: getCurrentInstance(),
                    component: editCompanyModal,
                    trapFocus: true,
                    props: {
                        company: props.company,
                        saveAs: "invenias"
                    },
                    events: {
                        saved: async (result) => {
                            if (result) {
                                search.value = result.company.ZI_C_COMPANY_NAME;
                                result.close();
                                await SearchCompanies();
                            }
                        }
                    }
                });
                */
            }

            const ConfirmNewCompany = async () => {
                if (confirm("You are about to create a new company. Are you sure?")) {
                    await NewCompany();
                }
            }

            watch(() => selection.value, (n, o) => {
                if (n != o) {
                    GetInveniasCompanyInfo(n);
                }
            });

            onMounted(() => {
                SearchCompanies();
            })

            return {
                loadingInfo,
                loading,
                isValid,
                options,
                selection,
                info,
                tab,
                search,
                creating,
                defaultWebsite,
                totalPeople,
                totalAssignments,
                SearchCompanies,
                Close,
                Link,
                NewCompany,
                ConfirmNewCompany
            };
        }
    };
</script>
<style>
    .link-company-border {
        border: 1px solid black;
        border-radius: 3px;
    }
</style>
